import PropTypes from 'prop-types'
import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { CustomPrice } from '../../../../../../common/order/customPrice'
import { PopupContactUs } from '../../../../../../common/order/popup/popupContactUs'
import classes from '../../../../../index.module.scss'
import { SelectOrEnterCode } from '../SelectOrEnterCode'

export const Price = ({
  price,
  oldPrice,
  appendStyleTitle,
  appendStylePrice,
  classNamePrice,
  title,
  isDiscount,
  exchangeRateAPI,
  isShowContactUs,
  isLastRow,
  priceDiscountDetails,
}) => {
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  const openPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  return (
    <div className={`flexRow ${!isLastRow ? classes.fieldRow : ''}`}>
      <Element
        className={[classes.title, 'fw600 '].join(' ')}
        style={{ ...Price.defaultProps.appendStyleTitle, ...appendStyleTitle }}
      >
        <Translate value={title} />
      </Element>
      {!isShowContactUs ? (
        <CustomPrice
          oldPrice={oldPrice}
          value={price || 0}
          styleIcon={{ width: 14, height: 14 }}
          style={{
            ...Price.defaultProps.appendStylePrice,
            ...appendStylePrice,
          }}
          className={classNamePrice}
          exchangeRateAPI={exchangeRateAPI}
        />
      ) : (
        <Element
          style={{ color: '#2C73E8', cursor: 'pointer' }}
          className={`dFlex alignItemsCenter justifyContentEnd ${classNamePrice}`}
          onClick={openPopupContactUs}
        >
          <Translate value="domesticSearchPreview.CONTACT_US" />
        </Element>
      )}
      {isShowContactUs && (
        <PopupContactUs
          isOpen={isOpenPopupContactUs}
          onClose={onClosePopupContactUs}
        />
      )}
      {isDiscount && (
        <SelectOrEnterCode
          price={price}
          isDiscount={isDiscount}
          priceDiscountDetails={priceDiscountDetails}
        />
      )}
    </div>
  )
}

Price.propTypes = {
  price: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  oldPrice: PropTypes.number,
  appendStyleTitle: PropTypes.object,
  appendStylePrice: PropTypes.object,
  classNamePrice: PropTypes.string,
  isDiscount: PropTypes.bool,
  exchangeRateAPI: PropTypes.number,
  isShowContactUs: PropTypes.bool,
}

Price.defaultProps = {
  price: 0,
  appendStyleTitle: { width: 160 },
  appendStylePrice: { fontWeight: 600, color: '#2C73E8' },
}
